module.exports = __webpack_public_path__ + "static/logo-dark-bf5d936ac2d35b3a516cc3a8cf2c20ff.svg";